import React from 'react';
import './banner.css'

const Banner = () => {
    return (
        <div>
          <section id='home'>
<div className='container'>
<h5 className='h5'>NEW ARRAIVAL</h5>
<h1 className='h1'><span>Best Price </span>this year</h1>
<p>Shoomatic offers your very comfortable time <br />on working and exerise</p>
<button>Shop Now</button>
</div>
          </section>
        </div>
    );
};

export default Banner;